import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'container my-25 max-md:my-15',
    container:
      'mx-auto flex items-center justify-center gap-13.5 max-lg:gap-6 max-md:flex-col max-md:gap-3',
    divider: 'bg-main h-16 w-0.5 shrink-0 max-md:hidden',
    naos: 'h-auto w-[340px] shrink-0 max-xl:w-[300px] max-lg:w-[240px]',
    logo: 'max-xs:h-12 max-xs:w-auto flex h-16 w-[162px] items-center justify-center max-lg:w-[132px]',
    brands: 'flex gap-[58px] max-lg:gap-4',
    bioderma: 'max-xs:w-[100px] h-auto w-[171px] max-lg:w-[141px]',
    esthederm: 'max-xs:w-[87px] h-auto w-[142px] px-2.5 max-lg:w-[112px]',
    etatPur: 'max-xs:w-[90px] h-auto w-[146px] px-2 max-lg:w-[116px]'
  }
});
